import React from "react";

export default function SQLServer_USER_NAME() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQLServer_USER_NAME</h1>
      <p>This is the SQLServer_USER_NAME component generated from the SQL JSON.</p>
    </div>
  );
}
